import React, { useContext, useRef, useEffect } from 'react'
import styled, { ThemeContext, keyframes } from 'styled-components'
import Col from './Column'
import StyledButton from './Button'
// import { OutSideClick } from '../Utility/Method/OutSideClick'
const Anim = keyframes`
0%{
    opacity : 0
}
100% {
    opacity : 1
}
`
const ConfirmWrapper = styled.div`
width : 100vw;
right : 0;
left : 0;
top : 130px;
height : 100vh;
z-index : 150;
display : ${props => props.show ? 'flex' : 'none'} ;
/* border: 1px solid red; */
position : relative;
direction : rtl;
background-color : rgba(50, 50, 50, 0.45);
`
const Container = styled.div`
/* display : ${props => props.show ? 'flex' : 'none'} ; */
justify-content : ${props => props.justifyContent || 'center'} ;
align-items : center;
justify-content:space-evenly ;
flex-direction : ${props => props.flexDir || 'column'} ;
direction : ${props => props.lang === 'fa' || props.lang === 'ar' ? 'rtl' : 'ltr'} ;
position : absolute ;
z-index : ${props => props.zIndex || 250} ;
top : ${props => props.top || 'unset'} ;
left : ${props => props.left || '0px'} ;
min-width : ${props => props.minWidth || props.width || '250px'} ;
min-height : ${props => props.minHeight || props.height || '150px'} ;
background-color : ${props => props.backgroundColor || props.theme.white} ;
width : ${props => props.width || 'auto'} ;
height : ${props => props.height || 'auto'} ;
color : ${props => props.color || props.theme.white} ;
border-radius : ${props => props.borderRadius || props.theme.borderRadius} ;
box-shadow : ${props => props.shadow || props.theme.shadowDark} ;
-webkit-box-shadow: ${props => props.shadow || props.theme.shadowDark} ;
-moz-box-shadow: ${props => props.shadow || props.theme.shadowDark} ;
`
const Confirm = (props) => {
    const theme = useContext(ThemeContext);
    const confirmRef = useRef();

    // useEffect(() => {
    //     window.addEventListener('mousedown', (e) => OutSideClick (e, props.innerRef , props.onCancel), false)
    //     return (() => {
    //         window.removeEventListener('mousedown', (e) => OutSideClick (e ,props.innerRef , props.onCancel), false)
    //     });
    // }, [])
    return (
        // props.show &&
        // <ConfirmWrapper
        //     {...props}
        //     ref={props.innerRef}
        //     className={props.className}
        // >
        <Container
            {...props}
            theme={theme}
            ref={props.innerRef}
            className={props.className}
        >
            <Col
                style={{
                    height: props.height ? `${props.height - '60px'}` : '60%',
                    width: '90%'
                }}
            >
                {props.children}
            </Col>
            <Col
                height='1px'
                style={{
                    backgroundColor: `${theme.lightGray}`,
                    width: '90%'
                }}
            >
            </Col>
            <Col
                justifyContent='space-between'
                height='60px'
                style={{
                    // backgroundColor : `${theme.text}`,
                    width: '90%'
                }}
            >
                <StyledButton
                    backgroundColor={props => props.okType || theme.primary}
                    color={props => props.okTextColor || theme.white}
                    width='80px'
                    onClick={props.onConfirm}
                >
                    {props.okText}
                </StyledButton>
                <StyledButton
                    default
                    backgroundColor={props.cancelType || theme.white}
                    color={props.cancelTextColor || theme.text}
                    width='40px'
                    notHoverable
                    style={{
                        border: 'none',
                        fontWeight: '800'
                    }}
                    onClick={props.onCancel}
                >
                    {props.cancelText}
                </StyledButton>
            </Col>
        </Container>
        // </ConfirmWrapper>
    )
}


export default Confirm
